module.exports = __webpack_public_path__ + "static/media/15.f1e4846b.JPG";